<script setup lang='ts'>
import { logicSeriesNewComplaint } from '~/logic/reputation/detail'

const props = withDefaults(defineProps<{
  brandId?: number
  brandName?: string
  seriesId?: number
  seriesName?: string
}>(), {
  brandId: 0,
  brandName: '',
  seriesId: 0,
  seriesName: '',
})

const {
  state,
  newComplaintList,
  getSeriesNewComplaint,
} = logicSeriesNewComplaint()

watch(() => props.seriesId, (nv, ov) => {
  if (nv && nv !== ov)
    getSeriesNewComplaint(nv)
}, { immediate: true })
</script>

<template>
  <div class="border-1 border-slate-2 rounded-md text-3.5 ">
    <div class="py-3 px-6 bg-slate-1 flex justify-between">
      <div>{{ props.brandName }}-{{ props.seriesName }}最新投诉</div>
      <NuxtLink target="_blank" :to="`/complaint/search?brandId=${brandId}&seriesId=${seriesId}`">
        <span>更多</span>
        <i class="i-ep:d-arrow-right" />
      </NuxtLink>
    </div>
    <div class="new-header py-4 flex items-center px-6">
      <div>车型</div>
      <div class="flex-grow min-w-0 mx-8 text-center">
        投诉概况
      </div>
      <div>投诉时间</div>
    </div>

    <UtilLoadState :state="state" :reload-handler="() => getSeriesNewComplaint(props.seriesId)">
      <div v-if="!newComplaintList.length" class="flex items-center justify-center py-6">
        <BasicEmpty text="暂无相关数据" />
      </div>
      <NuxtLink
        v-for="v in newComplaintList" :key="v.complainId"
        :to="`/complaint/detail/${v.complainId}`"
        class="new-item hover:text-orange-6 flex items-center px-6"
      >
        <span>{{ v.carModelName }}</span>
        <span class="line-clamp-1 flex-grow min-w-0 mx-8 overflow-hidden">
          {{ v.complainTitle }}
        </span>
        <span>{{ v.complainCreateTime }}</span>
      </NuxtLink>
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>
.new-header,
.new-item {
  --uno: border-b-1 border-dashed border-slate-2;

  &:last-child {
    border-bottom-width: 0;
  }

  & *:first-child {
    width: 250px;
    text-align: center;
    flex-shrink: 0;
  }

  & *:last-child {
    width: 100px;
    text-align: center;
    flex-shrink: 0;
  }
}

.new-item {
  padding: 16px 24px;
}
</style>
